/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logo': {
    width: 37,
    height: 31,
    viewBox: '0 0 37 31',
    data: '<path pid="0" d="M36.3 7.9V5.48a5.18 5.18 0 01-5.2-5.2h-2.48a5.18 5.18 0 01-5.18 5.2V7.9a7.58 7.58 0 005.24-2v1.3a5.2 5.2 0 01-5.18 5.2v2.32a7.58 7.58 0 005.24-2v1.16a5.182 5.182 0 01-5.3 5.12v2.4a7.58 7.58 0 005.24-2v3.48a5.2 5.2 0 11-10.38 0V9A7.67 7.67 0 002.96 9v12.56a4.1 4.1 0 00-2.96 4 4.16 4.16 0 105.34-4V9a5.21 5.21 0 1110.42 0v13.76a7.62 7.62 0 0015.24 0V19.3a7.54 7.54 0 005.24 2V19a5.183 5.183 0 01-5.2-5.2v-1.18a7.54 7.54 0 005.24 2V12.3a5.2 5.2 0 01-5.2-5.2V5.8a7.54 7.54 0 005.22 2.1zM6.98 25.54a2.84 2.84 0 11-5.66.476 2.84 2.84 0 015.66-.477z" _fill="#BECD47"/>'
  }
})
